import {CpcDiscountSchemeEndpointsApiService} from "@/main";
import {DiscountSchemeOverviewRestDto, DiscountSchemeRestDto,} from "@/api/pharma-cpc-mgmt/models";
import {MoveActionEnum} from "@/models/enum/MoveActionEnum";


export default {
    state() {
        return {
            discount_scheme: {} as DiscountSchemeRestDto,
            discount_schemes: [] as DiscountSchemeOverviewRestDto[],
        };
    },
    actions: {
        async deleteDiscountScheme(context: any, id: string) {
            await CpcDiscountSchemeEndpointsApiService.deleteDiscountScheme(id);
        },
        async moveDiscountScheme(context: any, payload: any) {
            const id = payload.id as string;
            const moveAction = payload.move_action as MoveActionEnum;

            switch (moveAction) {
                case MoveActionEnum.TOP:
                    await CpcDiscountSchemeEndpointsApiService.moveDiscountSchemeToTop(id);
                    break;
                case MoveActionEnum.BOTTOM:
                    await CpcDiscountSchemeEndpointsApiService.moveDiscountSchemeToBottom(id);
                    break;
                case MoveActionEnum.UP:
                    await CpcDiscountSchemeEndpointsApiService.moveDiscountSchemeUp(id);
                    break;
                case MoveActionEnum.DOWN:
                    await CpcDiscountSchemeEndpointsApiService.moveDiscountSchemeDown(id);
                    break;
                default:
                    throw new Error('Unsupported moveAction to call ' + moveAction);
            }
        },
        async searchDiscountSchemes(context: any) {
            const response = await CpcDiscountSchemeEndpointsApiService.findDiscountSchemes(undefined);
            context.commit('setDiscountSchemes', response.data);
        },
    },
    mutations: {
        setDiscountSchemes(state: any, discount_schemes: DiscountSchemeOverviewRestDto[]) {
            state.discount_schemes = discount_schemes;
        },
    },
    getters: {
        getDiscountScheme(state: any): DiscountSchemeRestDto {
            return state.discount_scheme;
        },
        getDiscountSchemes(state: any): DiscountSchemeOverviewRestDto[] {
            return state.discount_schemes;
        }
    },
}
